export default __webpack_public_path__ + "static/media/avatar-04.e6b364c1.png";